import { type ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { CircularProgress } from '@mui/material';
import { MutationSpinnerBoxCenter } from './styles';

const MutationSpinner = (): ReactElement<any, any> => {
    const isLoading = useSelector((state: any) => state.loading.isLoading);

    if (!isLoading) return <></>;

    return (
        <MutationSpinnerBoxCenter>
            <CircularProgress color='primary' />
        </MutationSpinnerBoxCenter>
    );
}

export default MutationSpinner
